export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Cursor: { input: any; output: any; }
  MoneyAmount: { input: any; output: any; }
  Time: { input: any; output: any; }
  URL: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AuthenticationResult = {
  __typename?: 'AuthenticationResult';
  token: Scalars['String']['output'];
  viewer: Viewer;
};

export type Banner = Node & {
  __typename?: 'Banner';
  button?: Maybe<BannerButton>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  image: Scalars['URL']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type BannerButton = {
  __typename?: 'BannerButton';
  bgColor?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

/** Тип для игр со ставками */
export type BettingGame = Node & {
  __typename?: 'BettingGame';
  /** Принимаемые валюты для ставок */
  acceptedCurrencies: Array<Currency>;
  /** Список ставок */
  bets: UserBetConnection;
  /** Общее количество ставок */
  betsNum?: Maybe<Scalars['Int']['output']>;
  /** Время завершения */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** Цвет подсветки карточки */
  highlightColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Флаг отмены баттла */
  isCanceled: Scalars['Boolean']['output'];
  /** Флаг завершения баттла */
  isCompleted: Scalars['Boolean']['output'];
  /** Флаг начала баттла */
  isStarted: Scalars['Boolean']['output'];
  /** Информация о джекпоте */
  jackpot?: Maybe<Jackpot>;
  /** Метки для фильтрации */
  labels: Array<Scalars['String']['output']>;
  /** Ставки текущего пользователя */
  myBets: Array<UserBet>;
  /** Подарки текущего пользователя */
  myGifts: Array<Gift>;
  /** Название баттла с учетом локали */
  name: Scalars['String']['output'];
  /** Возможные исходы баттла */
  outcomes: Array<BettingGameOutcome>;
  /** Период проведения баттла */
  period: DateInterval;
  /** Комиссия площадки */
  rake?: Maybe<Scalars['Float']['output']>;
};


/** Тип для игр со ставками */
export type BettingGameBetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Тип для игр со ставками */
export type BettingGameNameArgs = {
  locale?: InputMaybe<Locale>;
};

/** Соединение для пагинации баттлов */
export type BettingGameConnection = {
  __typename?: 'BettingGameConnection';
  /** Список баттлов */
  edges: Array<BettingGameEdge>;
  /** Информация о пагинации */
  pageInfo: PageInfo;
};

/** Элемент списка баттлов */
export type BettingGameEdge = {
  __typename?: 'BettingGameEdge';
  /** Курсор для пагинации */
  cursor: Scalars['Cursor']['output'];
  /** Баттл */
  node: BettingGame;
};

/** Исход в баттле */
export type BettingGameOutcome = {
  __typename?: 'BettingGameOutcome';
  /** Количество ставок */
  betsNum?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Матчи */
  matches: Array<Match>;
  /** Сумма в пуле */
  poolSum?: Maybe<Money>;
  /** Результат (если баттл завершен) */
  result?: Maybe<Scalars['Int']['output']>;
  /** Предмет ставки */
  subject: BettingGameSubject;
};

/** Предмет ставки (карточка игрока) */
export type BettingGameSubject = PlayerCardBettingGame;

export type BillingDetails = {
  __typename?: 'BillingDetails';
  crypto?: Maybe<CryptoDetails>;
  links: Array<PaymentLink>;
};

export type Card = Node & {
  __typename?: 'Card';
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isAtAuction: Scalars['Boolean']['output'];
  isOnSale: Scalars['Boolean']['output'];
  links: Array<CardLink>;
  multiplier: Scalars['Float']['output'];
  player: Player;
  price?: Maybe<Money>;
  rarity: Rarity;
  tenancy?: Maybe<CardTenancy>;
  tier: Scalars['Int']['output'];
};

export type CardConnection = {
  __typename?: 'CardConnection';
  edges: Array<CardEdge>;
  pageInfo: PageInfo;
};

export type CardDistributionRule = {
  __typename?: 'CardDistributionRule';
  cardFilter: CardFilter;
  odds: Scalars['Int']['output'];
};

export type CardEdge = {
  __typename?: 'CardEdge';
  cursor: Scalars['Cursor']['output'];
  node: Card;
};

export type CardFilter = {
  __typename?: 'CardFilter';
  positions?: Maybe<Array<PlayerPosition>>;
  rarities?: Maybe<Array<Rarity>>;
  teams?: Maybe<Array<Team>>;
  tiers?: Maybe<Array<Scalars['Int']['output']>>;
  tournaments?: Maybe<Array<Tournament>>;
};

export type CardLink = {
  __typename?: 'CardLink';
  provider: CardLinkProvider;
  url: Scalars['String']['output'];
};

export enum CardLinkProvider {
  Getgems = 'GETGEMS'
}

export enum CardOrder {
  Default = 'DEFAULT',
  L5Asc = 'L5_ASC',
  L5Dsc = 'L5_DSC',
  L15Asc = 'L15_ASC',
  L15Dsc = 'L15_DSC',
  PriceAsc = 'PRICE_ASC',
  PriceDsc = 'PRICE_DSC'
}

export type CardPrize = RoulettePrize & {
  __typename?: 'CardPrize';
  card: Card;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  number: Scalars['Int']['output'];
};

export type CardRestriction = {
  __typename?: 'CardRestriction';
  isCaptain?: Maybe<Scalars['Boolean']['output']>;
  maxCount?: Maybe<Scalars['Int']['output']>;
  minCount?: Maybe<Scalars['Int']['output']>;
  rarities?: Maybe<Array<Rarity>>;
};

export type CardTenancy = {
  __typename?: 'CardTenancy';
  gamesLeft: Scalars['Int']['output'];
  tenancyEndsAt?: Maybe<Scalars['Time']['output']>;
};

export type CardValues = {
  __typename?: 'CardValues';
  citizenship: Array<Scalars['String']['output']>;
  positions: Array<PlayerPosition>;
  rarities: Array<Rarity>;
  teams: Array<Team>;
  tiers: Array<Scalars['Int']['output']>;
  tournaments: Array<Tournament>;
};

export type CommonPack = Node & {
  __typename?: 'CommonPack';
  cardFilter: CardFilter;
  createdAt: Scalars['Time']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  game?: Maybe<Game>;
  id: Scalars['ID']['output'];
  isClaimed: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  userTeamId?: Maybe<Scalars['ID']['output']>;
};


export type CommonPackNameArgs = {
  locale?: InputMaybe<Locale>;
};

export type CryptoDetails = {
  __typename?: 'CryptoDetails';
  address: Scalars['String']['output'];
  amount: Scalars['MoneyAmount']['output'];
  decimals?: Maybe<Scalars['Int']['output']>;
  jettonAddress?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export enum Currency {
  Aed = 'AED',
  Btc = 'BTC',
  Eth = 'ETH',
  Eur = 'EUR',
  Fntf = 'FNTF',
  Fton = 'FTON',
  Gbp = 'GBP',
  Jetton = 'JETTON',
  Not = 'NOT',
  Rub = 'RUB',
  Ston = 'STON',
  Tcn = 'TCN',
  Testtusd = 'TESTTUSD',
  Ton = 'TON',
  Usd = 'USD',
  Usdt = 'USDT',
  Usdterc20 = 'USDTERC20',
  Usdttrc20 = 'USDTTRC20',
  Xtr = 'XTR'
}

export type DateInterval = {
  __typename?: 'DateInterval';
  from: Scalars['Time']['output'];
  to: Scalars['Time']['output'];
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  amount: Scalars['MoneyAmount']['output'];
  source: Currency;
  target: Currency;
};

export type Game = Node & {
  __typename?: 'Game';
  acceptedCurrencies?: Maybe<Array<Currency>>;
  cardsPointsCap?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  giftRuleSystemId?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['ID']['output'];
  guarantee?: Maybe<Money>;
  hasMyTicket: Scalars['Boolean']['output'];
  highlightColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  isCreatedByMe: Scalars['Boolean']['output'];
  isMainEvent: Scalars['Boolean']['output'];
  isMultiteam: Scalars['Boolean']['output'];
  isNft?: Maybe<Scalars['Boolean']['output']>;
  isOneMatchGame: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  isPvP: Scalars['Boolean']['output'];
  isStarted: Scalars['Boolean']['output'];
  labels: Array<Scalars['String']['output']>;
  leaderboardChallenge?: Maybe<LeaderboardChallenge>;
  matchTeams: Array<Team>;
  matches: Array<Match>;
  myGifts: Array<Gift>;
  myTasks: Array<GameTask>;
  myTeams: Array<UserTeam>;
  name: Scalars['String']['output'];
  numberInGroup: Scalars['Int']['output'];
  numberOfMatches: Scalars['Int']['output'];
  numberOfTeams?: Maybe<Scalars['Int']['output']>;
  period: DateInterval;
  playersOnTheSameTeamLimit: Scalars['Int']['output'];
  priceDiscount?: Maybe<Scalars['Float']['output']>;
  prototypeGameId?: Maybe<Scalars['ID']['output']>;
  rake?: Maybe<Scalars['Float']['output']>;
  requirements?: Maybe<GameRequirements>;
  scoringSystemVersion: Scalars['Int']['output'];
  suggestedCommonPacks: Array<CommonPack>;
  teamSize: Scalars['Int']['output'];
  teams: UserTeamConnection;
  teamsPerUserLimit: Scalars['Int']['output'];
  ticketPrice?: Maybe<Money>;
  tournamentTeams: Array<TournamentTeam>;
  tournaments: Array<Tournament>;
};


export type GameDescriptionArgs = {
  locale?: InputMaybe<Locale>;
};


export type GameNameArgs = {
  locale?: InputMaybe<Locale>;
};


export type GameTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type GameConnection = {
  __typename?: 'GameConnection';
  edges: Array<GameEdge>;
  pageInfo: PageInfo;
};

export type GameEdge = {
  __typename?: 'GameEdge';
  cursor: Scalars['Cursor']['output'];
  node: Game;
};

export type GameFilter = {
  __typename?: 'GameFilter';
  isNft?: Maybe<Scalars['Boolean']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  ticketPrice?: Maybe<MoneyRange>;
};

export enum GameLifecycleStage {
  Canceled = 'CANCELED',
  Finished = 'FINISHED',
  Ongoing = 'ONGOING',
  Upcoming = 'UPCOMING'
}

export type GameLifecycleStageIntKeyValueItem = {
  __typename?: 'GameLifecycleStageIntKeyValueItem';
  key?: Maybe<GameLifecycleStage>;
  val: Scalars['Int']['output'];
};

export type GameRequirements = {
  __typename?: 'GameRequirements';
  cardRestrictions: Array<CardRestriction>;
  id: Scalars['ID']['output'];
};

export type GameTask = {
  __typename?: 'GameTask';
  checkpoint: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};


export type GameTaskNameArgs = {
  locale?: InputMaybe<Locale>;
};

export type GameTeam = {
  __typename?: 'GameTeam';
  captain?: Maybe<Card>;
  cards: Array<Card>;
  positionStructure: Array<Scalars['String']['output']>;
};

export type GameValues = {
  __typename?: 'GameValues';
  labels: Array<IntKeyValueItem>;
  lifecycleStages: Array<GameLifecycleStageIntKeyValueItem>;
  ticketPrices: Array<MoneyIntKeyValueItem>;
};

export type Gift = CommonPack | MoneyReward | NftCardGiveaway | SeasonTicketReward;

export type GiftConnection = {
  __typename?: 'GiftConnection';
  edges: Array<GiftEdge>;
  pageInfo: PageInfo;
};

export type GiftEdge = {
  __typename?: 'GiftEdge';
  cursor: Scalars['Cursor']['output'];
  node: Gift;
};

export type GiftRule = GiftRuleForSeasonTicketReward;

export type GiftRuleForSeasonTicketReward = Node & {
  __typename?: 'GiftRuleForSeasonTicketReward';
  gameFilter: GameFilter;
  id: Scalars['ID']['output'];
  size: Scalars['Int']['output'];
};

export type IntKeyValueItem = {
  __typename?: 'IntKeyValueItem';
  key?: Maybe<Scalars['String']['output']>;
  val: Scalars['Int']['output'];
};

export type IntRangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type InviteeEventSummary = {
  __typename?: 'InviteeEventSummary';
  playedFreeGame: Scalars['Int']['output'];
  playedPaidGame: Scalars['Int']['output'];
};

export type InviteeStats = {
  __typename?: 'InviteeStats';
  inviterReward: Money;
};

export type InviterRewardDetails = {
  __typename?: 'InviterRewardDetails';
  bettingGames: Money;
  games: Money;
  subscriptions: Money;
  tasks: Money;
};

export type InviterStats = {
  __typename?: 'InviterStats';
  inviteeEventSummary: InviteeEventSummary;
  numberOfInvitees: Scalars['Int']['output'];
  numberOfReferees: Scalars['Int']['output'];
  rewardDetails: InviterRewardDetails;
  seasonTicketSummary: SeasonTicketSummary;
  totalReward: Money;
};

/** Джекпот */
export type Jackpot = Node & {
  __typename?: 'Jackpot';
  /** Гарантированная сумма */
  guarantee: Money;
  id: Scalars['ID']['output'];
  /** Флаг выплаты */
  isCompleted: Scalars['Boolean']['output'];
  /** Текущая серия побед */
  myWinStreak?: Maybe<Scalars['Int']['output']>;
  /** Участники */
  participants: JackpotParticipantConnection;
  /** Текущая сумма в пуле */
  poolSum?: Maybe<Money>;
};


/** Джекпот */
export type JackpotParticipantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type JackpotParticipant = Node & {
  __typename?: 'JackpotParticipant';
  account: UserAccount;
  id: Scalars['ID']['output'];
  winStreak: Scalars['Int']['output'];
};

export type JackpotParticipantConnection = {
  __typename?: 'JackpotParticipantConnection';
  edges: Array<JackpotParticipantEdge>;
  pageInfo: PageInfo;
};

export type JackpotParticipantEdge = {
  __typename?: 'JackpotParticipantEdge';
  cursor: Scalars['Cursor']['output'];
  node: JackpotParticipant;
};

export type LeaderboardChallenge = Node & {
  __typename?: 'LeaderboardChallenge';
  entryPrice?: Maybe<Money>;
  giftRuleSystemId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isStarted: Scalars['Boolean']['output'];
  myGifts: Array<Gift>;
  myPosition: LeaderboardParticipant;
  name: Scalars['String']['output'];
  numberOfParticipants: Scalars['Int']['output'];
  participants: LeaderboardParticipantConnection;
  period: DateInterval;
  prizePool?: Maybe<Money>;
  scoringSystemVersion: Scalars['Int']['output'];
};


export type LeaderboardChallengeNameArgs = {
  locale?: InputMaybe<Locale>;
};


export type LeaderboardChallengeParticipantsArgs = {
  accounts?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type LeaderboardChallengeConnection = {
  __typename?: 'LeaderboardChallengeConnection';
  edges: Array<LeaderboardChallengeEdge>;
  pageInfo: PageInfo;
};

export type LeaderboardChallengeEdge = {
  __typename?: 'LeaderboardChallengeEdge';
  cursor: Scalars['Cursor']['output'];
  node: LeaderboardChallenge;
};

export enum LeaderboardLevel {
  WorldClub = 'WORLD_CLUB'
}

export type LeaderboardParticipant = Node & {
  __typename?: 'LeaderboardParticipant';
  account: UserAccount;
  challenge: LeaderboardChallenge;
  giftsLeft?: Maybe<Scalars['Int']['output']>;
  history: UserTeamConnection;
  id: Scalars['ID']['output'];
  level?: Maybe<LeaderboardLevel>;
  place?: Maybe<Scalars['Int']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type LeaderboardParticipantHistoryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type LeaderboardParticipantConnection = {
  __typename?: 'LeaderboardParticipantConnection';
  edges: Array<LeaderboardParticipantEdge>;
  pageInfo: PageInfo;
};

export type LeaderboardParticipantEdge = {
  __typename?: 'LeaderboardParticipantEdge';
  cursor: Scalars['Cursor']['output'];
  node: LeaderboardParticipant;
};

export type LineupDetails = {
  __typename?: 'LineupDetails';
  isCaptain: Scalars['Boolean']['output'];
  isExpectedLineupPlayer: Scalars['Boolean']['output'];
  isExpectedReservePlayer: Scalars['Boolean']['output'];
  isLineupPlayer: Scalars['Boolean']['output'];
  isReservePlayer: Scalars['Boolean']['output'];
};

export enum Locale {
  En = 'EN',
  Ru = 'RU'
}

export type LootBoxOffer = Node & {
  __typename?: 'LootBoxOffer';
  distributionRules: Array<CardDistributionRule>;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  itemsLeft: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberOfItems: Scalars['Int']['output'];
  price: Money;
  valueClass: LootBoxValueClass;
};


export type LootBoxOfferNameArgs = {
  locale?: InputMaybe<Locale>;
};

export type LootBoxOfferConnection = {
  __typename?: 'LootBoxOfferConnection';
  edges: Array<LootBoxOfferEdge>;
  pageInfo: PageInfo;
};

export type LootBoxOfferEdge = {
  __typename?: 'LootBoxOfferEdge';
  cursor: Scalars['Cursor']['output'];
  node: LootBoxOffer;
};

export type LootBoxPurchase = Node & {
  __typename?: 'LootBoxPurchase';
  cards: Array<Card>;
  id: Scalars['ID']['output'];
};

export enum LootBoxValueClass {
  Bronze = 'BRONZE',
  Gold = 'GOLD',
  Silver = 'SILVER'
}

export type Match = Node & {
  __typename?: 'Match';
  awayTeam: Team;
  caption?: Maybe<Scalars['String']['output']>;
  homeTeam: Team;
  id: Scalars['ID']['output'];
  matchDay: Scalars['Time']['output'];
  odds: Array<MatchOdds>;
  playerStats: Array<PlayerStatValue>;
  score?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['Time']['output']>;
  status: MatchStatus;
  tournament: Tournament;
};


export type MatchPlayerStatsArgs = {
  players?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MatchConnection = {
  __typename?: 'MatchConnection';
  edges: Array<MatchEdge>;
  pageInfo: PageInfo;
};

export type MatchEdge = {
  __typename?: 'MatchEdge';
  cursor: Scalars['Cursor']['output'];
  node: Match;
};

export type MatchEvent = Node & {
  __typename?: 'MatchEvent';
  id: Scalars['ID']['output'];
  match: Match;
  subtype?: Maybe<Scalars['String']['output']>;
  time: MatchTime;
  type: MatchEventType;
};

export enum MatchEventType {
  Card = 'CARD',
  End = 'END',
  Goal = 'GOAL',
  KickOff = 'KICK_OFF',
  MissedPenalty = 'MISSED_PENALTY',
  Substitution = 'SUBSTITUTION'
}

export type MatchOdds = {
  __typename?: 'MatchOdds';
  name: Scalars['String']['output'];
  probability: Scalars['Float']['output'];
};

export enum MatchStatus {
  Canceled = 'CANCELED',
  Finished = 'FINISHED',
  Live = 'LIVE',
  Postponed = 'POSTPONED',
  Scheduled = 'SCHEDULED',
  Undefined = 'UNDEFINED'
}

export type MatchTime = {
  __typename?: 'MatchTime';
  extra?: Maybe<Scalars['Int']['output']>;
  normal: Scalars['Int']['output'];
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  currency: Currency;
};

export type MoneyInput = {
  amount: Scalars['MoneyAmount']['input'];
  currency: Currency;
};

export type MoneyIntKeyValueItem = {
  __typename?: 'MoneyIntKeyValueItem';
  key?: Maybe<Money>;
  val: Scalars['Int']['output'];
};

export type MoneyRange = {
  __typename?: 'MoneyRange';
  max?: Maybe<Money>;
  min?: Maybe<Money>;
};

export type MoneyRangeInput = {
  max?: InputMaybe<MoneyInput>;
  min?: InputMaybe<MoneyInput>;
};

export type MoneyReward = Node & {
  __typename?: 'MoneyReward';
  createdAt: Scalars['Time']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  game?: Maybe<Game>;
  id: Scalars['ID']['output'];
  isClaimed: Scalars['Boolean']['output'];
  rewardSum: Money;
  userTeamId?: Maybe<Scalars['ID']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  buyLootBoxItem: LootBoxPurchase;
  buySubscription: Subscription;
  cancelSubscription?: Maybe<Scalars['Void']['output']>;
  checkGameTaskCheckpointPassed: Array<GameTask>;
  claimCommonPack?: Maybe<Scalars['Void']['output']>;
  claimMoneyReward?: Maybe<Scalars['Void']['output']>;
  claimNftCard: Gift;
  claimSeasonTicketReward: Gift;
  commitOnboardingStep?: Maybe<Scalars['Void']['output']>;
  createBillingDetails: BillingDetails;
  createNeoCryptoGameTicketPaymentLink: Scalars['String']['output'];
  createTelegramStarsInvoiceLink: Scalars['String']['output'];
  createTonkeeperGameTicketPaymentLink: Scalars['String']['output'];
  generateTonConnectPayload: Scalars['String']['output'];
  handleNeoCryptoPayment?: Maybe<Scalars['Void']['output']>;
  sendTelegramStarsInvoice?: Maybe<Scalars['Void']['output']>;
  signInViaTonConnect: AuthenticationResult;
  signOutViaTonConnect?: Maybe<Scalars['Void']['output']>;
  spinRouletteWheel?: Maybe<CardPrize>;
  stakeTokens?: Maybe<Scalars['Void']['output']>;
  submitBet?: Maybe<Scalars['Void']['output']>;
  submitGame: Game;
  submitTeam: UserTeam;
  swapTokens: WalletTransaction;
  withdrawFromWallet?: Maybe<Scalars['Void']['output']>;
  yieldGiftPack: Array<Gift>;
  yieldGiftPackForBettingGame: Array<Gift>;
  yieldGiftPackForLeaderboardChallenge: Array<Gift>;
};


export type MutationBuyLootBoxItemArgs = {
  lootBoxOfferId: Scalars['ID']['input'];
};


export type MutationBuySubscriptionArgs = {
  variant: Scalars['String']['input'];
};


export type MutationCheckGameTaskCheckpointPassedArgs = {
  checkpoint: Scalars['String']['input'];
  gameId: Scalars['ID']['input'];
};


export type MutationClaimCommonPackArgs = {
  cardIds: Array<Scalars['ID']['input']>;
  giftId: Scalars['ID']['input'];
};


export type MutationClaimMoneyRewardArgs = {
  giftId: Scalars['ID']['input'];
};


export type MutationClaimNftCardArgs = {
  giftId: Scalars['ID']['input'];
};


export type MutationClaimSeasonTicketRewardArgs = {
  giftId: Scalars['ID']['input'];
};


export type MutationCommitOnboardingStepArgs = {
  step: Scalars['String']['input'];
};


export type MutationCreateBillingDetailsArgs = {
  amount: Scalars['MoneyAmount']['input'];
  currency: Currency;
  depositType?: InputMaybe<WalletDepositType>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateNeoCryptoGameTicketPaymentLinkArgs = {
  gameId: Scalars['ID']['input'];
};


export type MutationCreateTelegramStarsInvoiceLinkArgs = {
  amount: Scalars['MoneyAmount']['input'];
  currency: Currency;
};


export type MutationCreateTonkeeperGameTicketPaymentLinkArgs = {
  gameId: Scalars['ID']['input'];
};


export type MutationHandleNeoCryptoPaymentArgs = {
  neoCryptoReqId: Scalars['String']['input'];
  paymentId: Scalars['ID']['input'];
};


export type MutationSendTelegramStarsInvoiceArgs = {
  amount: Scalars['MoneyAmount']['input'];
  currency: Currency;
};


export type MutationSignInViaTonConnectArgs = {
  locale: Scalars['String']['input'];
  tonProof: TonProofInput;
  walletName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStakeTokensArgs = {
  stakeDetails: StakeDetailsInput;
};


export type MutationSubmitBetArgs = {
  amount: Scalars['MoneyAmount']['input'];
  currency: Currency;
  gameId: Scalars['ID']['input'];
  outcomeId: Scalars['ID']['input'];
};


export type MutationSubmitGameArgs = {
  prototypeGameId: Scalars['ID']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationSubmitTeamArgs = {
  team: TeamInput;
};


export type MutationSwapTokensArgs = {
  fromTokenAmount: Scalars['MoneyAmount']['input'];
  fromTokenCurrency: Currency;
  toTokenCurrency: Currency;
};


export type MutationWithdrawFromWalletArgs = {
  amount: Scalars['MoneyAmount']['input'];
  currency: Currency;
  toWalletAddress: Scalars['String']['input'];
};


export type MutationYieldGiftPackArgs = {
  gameId: Scalars['ID']['input'];
};


export type MutationYieldGiftPackForBettingGameArgs = {
  gameId: Scalars['ID']['input'];
};


export type MutationYieldGiftPackForLeaderboardChallengeArgs = {
  leaderboardChallengeId: Scalars['ID']['input'];
};

export type NftCardGiveaway = Node & {
  __typename?: 'NftCardGiveaway';
  cardFilter: CardFilter;
  createdAt: Scalars['Time']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  game?: Maybe<Game>;
  id: Scalars['ID']['output'];
  isClaimed: Scalars['Boolean']['output'];
  rewardedCard?: Maybe<Card>;
  userTeamId?: Maybe<Scalars['ID']['output']>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PaymentLink = {
  __typename?: 'PaymentLink';
  link: Scalars['String']['output'];
  wallet: WalletProvider;
};

export type Player = Node & {
  __typename?: 'Player';
  avgScoreForLast5?: Maybe<Scalars['Int']['output']>;
  avgScoreForLast15?: Maybe<Scalars['Int']['output']>;
  cards: CardConnection;
  citizenship: Array<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  expectedScoreByMatch: Array<PlayerScore>;
  id: Scalars['ID']['output'];
  lineupDetails?: Maybe<LineupDetails>;
  name: Scalars['String']['output'];
  photo?: Maybe<Scalars['URL']['output']>;
  scoreByMatch: Array<PlayerScore>;
  teamIds: Array<Scalars['ID']['output']>;
  teams: TeamPlayerConnection;
  value?: Maybe<Money>;
};


export type PlayerCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PlayerExpectedScoreByMatchArgs = {
  scoringVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type PlayerNameArgs = {
  locale?: InputMaybe<Locale>;
};


export type PlayerScoreByMatchArgs = {
  scoringVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type PlayerTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Ставка на карточку игрока */
export type PlayerCardBettingGame = {
  __typename?: 'PlayerCardBettingGame';
  /** Карточка игрока */
  card: Card;
};

export type PlayerEvent = Node & {
  __typename?: 'PlayerEvent';
  id: Scalars['ID']['output'];
  matchEvent: MatchEvent;
  subtype?: Maybe<Scalars['String']['output']>;
  teamPlayer: TeamPlayer;
  type: PlayerEventType;
};

export enum PlayerEventType {
  Assist = 'ASSIST',
  Finish = 'FINISH',
  Goal = 'GOAL',
  In = 'IN',
  MissedPenalty = 'MISSED_PENALTY',
  Out = 'OUT',
  OwnGoal = 'OWN_GOAL',
  PenaltyFoul = 'PENALTY_FOUL',
  PenaltyGoal = 'PENALTY_GOAL',
  RedCard = 'RED_CARD',
  SavedPenalty = 'SAVED_PENALTY',
  SecondYellowCard = 'SECOND_YELLOW_CARD',
  Start = 'START',
  YellowCard = 'YELLOW_CARD'
}

export enum PlayerPosition {
  Back = 'BACK',
  Forward = 'FORWARD',
  Goalkeeper = 'GOALKEEPER',
  Midfield = 'MIDFIELD',
  Reserve = 'RESERVE'
}

export type PlayerScore = {
  __typename?: 'PlayerScore';
  matchDay: Scalars['Time']['output'];
  matchId: Scalars['ID']['output'];
  points: Scalars['Int']['output'];
};

export type PlayerStatValue = Node & {
  __typename?: 'PlayerStatValue';
  id: Scalars['ID']['output'];
  match: Match;
  scorePerUnit?: Maybe<Scalars['Float']['output']>;
  teamPlayer: TeamPlayer;
  totalScore?: Maybe<Scalars['Int']['output']>;
  type: PlayerStatValueType;
  value?: Maybe<Scalars['String']['output']>;
};

export enum PlayerStatValueType {
  AccurateCrosses = 'ACCURATE_CROSSES',
  AccuratePasses = 'ACCURATE_PASSES',
  AccuratePassesPercentage = 'ACCURATE_PASSES_PERCENTAGE',
  AerialsWon = 'AERIALS_WON',
  Assists = 'ASSISTS',
  BigChancesCreated = 'BIG_CHANCES_CREATED',
  BigChancesMissed = 'BIG_CHANCES_MISSED',
  BlockedShots = 'BLOCKED_SHOTS',
  Captain = 'CAPTAIN',
  Clearances = 'CLEARANCES',
  ClearanceOffline = 'CLEARANCE_OFFLINE',
  Dispossessed = 'DISPOSSESSED',
  DribbledAttempts = 'DRIBBLED_ATTEMPTS',
  DribbledPast = 'DRIBBLED_PAST',
  DuelsLost = 'DUELS_LOST',
  DuelsWon = 'DUELS_WON',
  ErrorLeadToGoal = 'ERROR_LEAD_TO_GOAL',
  Fouls = 'FOULS',
  FoulsDrawn = 'FOULS_DRAWN',
  GoalkeeperGoalsConceded = 'GOALKEEPER_GOALS_CONCEDED',
  Goals = 'GOALS',
  GoalsConceded = 'GOALS_CONCEDED',
  HitWoodwork = 'HIT_WOODWORK',
  Interceptions = 'INTERCEPTIONS',
  KeyPasses = 'KEY_PASSES',
  LongBalls = 'LONG_BALLS',
  LongBallsWon = 'LONG_BALLS_WON',
  MinutesPlayed = 'MINUTES_PLAYED',
  MissedPasses = 'MISSED_PASSES',
  Offsides = 'OFFSIDES',
  OwnGoals = 'OWN_GOALS',
  Passes = 'PASSES',
  PenaltiesCommitted = 'PENALTIES_COMMITTED',
  PenaltiesMisses = 'PENALTIES_MISSES',
  PenaltiesSaved = 'PENALTIES_SAVED',
  PenaltiesScored = 'PENALTIES_SCORED',
  PenaltiesWon = 'PENALTIES_WON',
  Punches = 'PUNCHES',
  Rating = 'RATING',
  RedCards = 'RED_CARDS',
  Saves = 'SAVES',
  SavesInsideBox = 'SAVES_INSIDE_BOX',
  ShotsBlocked = 'SHOTS_BLOCKED',
  ShotsOffTarget = 'SHOTS_OFF_TARGET',
  ShotsOnTarget = 'SHOTS_ON_TARGET',
  ShotsTotal = 'SHOTS_TOTAL',
  SuccessfulDribbles = 'SUCCESSFUL_DRIBBLES',
  Tackles = 'TACKLES',
  ThroughBalls = 'THROUGH_BALLS',
  ThroughBallsWon = 'THROUGH_BALLS_WON',
  TotalCrosses = 'TOTAL_CROSSES',
  TotalDuels = 'TOTAL_DUELS',
  YellowCards = 'YELLOW_CARDS',
  YellowRedCards = 'YELLOW_RED_CARDS'
}

export type PredictionBetDescription = {
  __typename?: 'PredictionBetDescription';
  eventTitle: Scalars['String']['output'];
  marketTitle: Scalars['String']['output'];
  outcomeLabel: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  banners: Array<Maybe<Banner>>;
  bettingGames: BettingGameConnection;
  cardValues: CardValues;
  cards: CardConnection;
  currentJackpot?: Maybe<Jackpot>;
  currentLeaderboardChallenge?: Maybe<LeaderboardChallenge>;
  exchangeRates: Array<ExchangeRate>;
  gameValues: GameValues;
  games: GameConnection;
  leaderboardChallenges: LeaderboardChallengeConnection;
  lootBoxOffers: LootBoxOfferConnection;
  matches: MatchConnection;
  node?: Maybe<Node>;
  players: TeamPlayerConnection;
  referees: RefereeConnection;
  scores: ScoreConnection;
  stakingTypes: Array<StakingType>;
  taskCampaigns: TaskCampaignConnection;
  viewer: Viewer;
};


export type QueryBettingGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasGiftToClaim?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  lifecycle?: InputMaybe<Array<GameLifecycleStage>>;
  myOwn?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCardValuesArgs = {
  citizenship?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedCards?: InputMaybe<Array<Scalars['ID']['input']>>;
  games?: InputMaybe<Array<Scalars['ID']['input']>>;
  myOwn?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<PlayerPosition>>;
  rarities?: InputMaybe<Array<Rarity>>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
  tiers?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['ID']['input']>>;
  userTeams?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  assistsAvg?: InputMaybe<IntRangeInput>;
  assistsLast5?: InputMaybe<IntRangeInput>;
  avgScoreLast5?: InputMaybe<IntRangeInput>;
  avgScoreLast15?: InputMaybe<IntRangeInput>;
  citizenship?: InputMaybe<Array<Scalars['String']['input']>>;
  cleanSheetsAvg?: InputMaybe<IntRangeInput>;
  cleanSheetsLast5?: InputMaybe<IntRangeInput>;
  commonPackId?: InputMaybe<Scalars['ID']['input']>;
  excludedCards?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  games?: InputMaybe<Array<Scalars['ID']['input']>>;
  goalsAvg?: InputMaybe<IntRangeInput>;
  goalsLast5?: InputMaybe<IntRangeInput>;
  isAtAuction?: InputMaybe<Scalars['Boolean']['input']>;
  isExpectedLineupPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isLineupPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  minutesPlayedAvg?: InputMaybe<IntRangeInput>;
  minutesPlayedLast5?: InputMaybe<IntRangeInput>;
  myOwn?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CardOrder>;
  positions?: InputMaybe<Array<PlayerPosition>>;
  price?: InputMaybe<MoneyRangeInput>;
  rarities?: InputMaybe<Array<Rarity>>;
  scoringVersion?: InputMaybe<Scalars['Int']['input']>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
  tiers?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['ID']['input']>>;
  userTeams?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGameValuesArgs = {
  exactTournaments?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasGiftToClaim?: InputMaybe<Scalars['Boolean']['input']>;
  isCreatedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  isMainEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isNft?: InputMaybe<Scalars['Boolean']['input']>;
  isOneMatchGame?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isPvP?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  lifecycle?: InputMaybe<Array<GameLifecycleStage>>;
  myOwn?: InputMaybe<Scalars['Boolean']['input']>;
  ticketPrice?: InputMaybe<MoneyRangeInput>;
  tournaments?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  exactTournaments?: InputMaybe<Array<Scalars['ID']['input']>>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasGiftToClaim?: InputMaybe<Scalars['Boolean']['input']>;
  isCreatedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  isMainEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isNft?: InputMaybe<Scalars['Boolean']['input']>;
  isOneMatchGame?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isPvP?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  leaderboardChallenges?: InputMaybe<Array<Scalars['ID']['input']>>;
  lifecycle?: InputMaybe<Array<GameLifecycleStage>>;
  myOwn?: InputMaybe<Scalars['Boolean']['input']>;
  ticketPrice?: InputMaybe<MoneyRangeInput>;
  tournaments?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryLeaderboardChallengesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasGiftToClaim?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  lifecycle?: InputMaybe<Array<GameLifecycleStage>>;
  myOwn?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLootBoxOffersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  players?: InputMaybe<Array<Scalars['ID']['input']>>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlayersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};


export type QueryRefereesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScoresArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  cards?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  games?: InputMaybe<Array<Scalars['ID']['input']>>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryTaskCampaignsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Rarity {
  Common = 'COMMON',
  Epic = 'EPIC',
  Legendary = 'LEGENDARY',
  Rare = 'RARE'
}

export type Referee = Node & {
  __typename?: 'Referee';
  id: Scalars['ID']['output'];
  inviteeStats: InviteeStats;
  name?: Maybe<Scalars['String']['output']>;
};

export type RefereeConnection = {
  __typename?: 'RefereeConnection';
  edges: Array<RefereeEdge>;
  pageInfo: PageInfo;
};

export type RefereeEdge = {
  __typename?: 'RefereeEdge';
  cursor: Scalars['Cursor']['output'];
  node: Referee;
};

export type RoulettePrize = {
  expiresAt?: Maybe<Scalars['Time']['output']>;
};

export type Score = Node & {
  __typename?: 'Score';
  card: Card;
  createdAt: Scalars['Time']['output'];
  event: PlayerEvent;
  id: Scalars['ID']['output'];
  points: Scalars['Int']['output'];
  ruleId: Scalars['ID']['output'];
  type: ScoreEventType;
};

export type ScoreConnection = {
  __typename?: 'ScoreConnection';
  edges: Array<ScoreEdge>;
  pageInfo: PageInfo;
};

export type ScoreEdge = {
  __typename?: 'ScoreEdge';
  cursor: Scalars['Cursor']['output'];
  node: Score;
};

export enum ScoreEventType {
  Gain = 'GAIN',
  Loss = 'LOSS'
}

export type SeasonTicket = {
  __typename?: 'SeasonTicket';
  gameFilter: GameFilter;
  gamesNum: Scalars['Int']['output'];
};

export type SeasonTicketReward = Node & {
  __typename?: 'SeasonTicketReward';
  createdAt: Scalars['Time']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  game?: Maybe<Game>;
  gameFilter: GameFilter;
  id: Scalars['ID']['output'];
  isClaimed: Scalars['Boolean']['output'];
  size: Scalars['Int']['output'];
  userTeamId?: Maybe<Scalars['ID']['output']>;
};

export type SeasonTicketSummary = {
  __typename?: 'SeasonTicketSummary';
  groupedByLabel: Array<SeasonTicketSummaryByLabel>;
  groupedByTicketPrice: Array<SeasonTicketSummaryByTicketPrice>;
  paidCommonGameTickets: Scalars['Int']['output'];
  paidNftGameTickets: Scalars['Int']['output'];
};

export type SeasonTicketSummaryByLabel = {
  __typename?: 'SeasonTicketSummaryByLabel';
  label: Scalars['String']['output'];
  numberOfTickets: Scalars['Int']['output'];
};

export type SeasonTicketSummaryByTicketPrice = {
  __typename?: 'SeasonTicketSummaryByTicketPrice';
  numberOfTickets: Scalars['Int']['output'];
  ticketPrice: MoneyRange;
};

export type StakeDetails = {
  __typename?: 'StakeDetails';
  apy: Scalars['Float']['output'];
  claimAt: Scalars['Time']['output'];
  createdAt: Scalars['Time']['output'];
  deposit: Money;
  duration: Scalars['Int']['output'];
  valueClass: StakeValueClass;
};

export type StakeDetailsInput = {
  depositAmount: Scalars['MoneyAmount']['input'];
  depositCurrency: Currency;
  duration: Scalars['Int']['input'];
  valueClass: StakeValueClass;
};

export enum StakeValueClass {
  Bronze = 'BRONZE',
  Gold = 'GOLD',
  Platinum = 'PLATINUM',
  Silver = 'SILVER'
}

export type StakingType = {
  __typename?: 'StakingType';
  apy: Scalars['Float']['output'];
  availableCount?: Maybe<Scalars['Int']['output']>;
  duration: Scalars['Int']['output'];
  minDeposit: Money;
  stakedCount?: Maybe<Scalars['Int']['output']>;
  valueClass: StakeValueClass;
};

export type Subscription = {
  __typename?: 'Subscription';
  benefits: SubscriptionBenefits;
  nextVariant?: Maybe<Scalars['String']['output']>;
  validThrough: Scalars['Time']['output'];
  variant: Scalars['String']['output'];
};

export type SubscriptionBenefits = {
  __typename?: 'SubscriptionBenefits';
  extraTeams: Scalars['Int']['output'];
  lootBoxDiscount: Scalars['Float']['output'];
  rakeDiscount: Scalars['Float']['output'];
  rouletteWheelSpins: Scalars['Int']['output'];
};

export type Task = Node & {
  __typename?: 'Task';
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};


export type TaskNameArgs = {
  locale?: InputMaybe<Locale>;
};

export type TaskCampaign = Node & {
  __typename?: 'TaskCampaign';
  description?: Maybe<Scalars['String']['output']>;
  giftRules: Array<GiftRule>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['URL']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  myGifts: Array<Gift>;
  name: Scalars['String']['output'];
  tasks: Array<Task>;
};


export type TaskCampaignDescriptionArgs = {
  locale?: InputMaybe<Locale>;
};


export type TaskCampaignNameArgs = {
  locale?: InputMaybe<Locale>;
};

export type TaskCampaignConnection = {
  __typename?: 'TaskCampaignConnection';
  edges: Array<TaskCampaignEdge>;
  pageInfo: PageInfo;
};

export type TaskCampaignEdge = {
  __typename?: 'TaskCampaignEdge';
  cursor: Scalars['Cursor']['output'];
  node: TaskCampaign;
};

export type Team = Node & {
  __typename?: 'Team';
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
};


export type TeamNameArgs = {
  locale?: InputMaybe<Locale>;
};

export type TeamInput = {
  captainCardId?: InputMaybe<Scalars['ID']['input']>;
  cardIds: Array<Scalars['ID']['input']>;
  currency?: InputMaybe<Currency>;
  gameId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
};

export type TeamPlayer = Node & {
  __typename?: 'TeamPlayer';
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  player: Player;
  position: PlayerPosition;
  team: Team;
  tournament: Tournament;
};

export type TeamPlayerConnection = {
  __typename?: 'TeamPlayerConnection';
  edges: Array<TeamPlayerEdge>;
  pageInfo: PageInfo;
};

export type TeamPlayerEdge = {
  __typename?: 'TeamPlayerEdge';
  cursor: Scalars['Cursor']['output'];
  node: TeamPlayer;
};

export type TonConnectDomainInput = {
  lengthBytes: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TonProofInput = {
  address: Scalars['String']['input'];
  network: Scalars['String']['input'];
  proof: TonProofMessageInfoInput;
};

export type TonProofMessageInfoInput = {
  domain: TonConnectDomainInput;
  payload: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  stateInit: Scalars['String']['input'];
  timestamp: Scalars['Time']['input'];
};

export type Tournament = Node & {
  __typename?: 'Tournament';
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
  season: Scalars['String']['output'];
};


export type TournamentNameArgs = {
  locale?: InputMaybe<Locale>;
};

export type TournamentTeam = Node & {
  __typename?: 'TournamentTeam';
  id: Scalars['ID']['output'];
  place?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  team: Team;
  tournament: Tournament;
};

export type UserAccount = {
  __typename?: 'UserAccount';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Ставка пользователя */
export type UserBet = Node & {
  __typename?: 'UserBet';
  /** Аккаунт пользователя */
  account: UserAccount;
  createdAt?: Maybe<Scalars['Time']['output']>;
  /** Оставшиеся подарки */
  giftsLeft?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isJackpotParticipant: Scalars['Boolean']['output'];
  /** Номер в игре */
  numberInGame?: Maybe<Scalars['Int']['output']>;
  /** Исход, на который сделана ставка */
  outcome: BettingGameOutcome;
  /** Сумма ставки */
  sum: Money;
};

export type UserBetConnection = {
  __typename?: 'UserBetConnection';
  edges: Array<UserBetEdge>;
  pageInfo: PageInfo;
};

export type UserBetEdge = {
  __typename?: 'UserBetEdge';
  cursor: Scalars['Cursor']['output'];
  node: UserBet;
};

export type UserTeam = Node & {
  __typename?: 'UserTeam';
  account: UserAccount;
  captain?: Maybe<Card>;
  cardScores: Array<Scalars['Int']['output']>;
  cards: Array<Card>;
  game: Game;
  giftsLeft?: Maybe<Scalars['Int']['output']>;
  groupIndex: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  initialTeam: GameTeam;
  leaderboardPoints?: Maybe<Scalars['Int']['output']>;
  numberInGame?: Maybe<Scalars['Int']['output']>;
  place: Scalars['Int']['output'];
  positionStructure: Array<Scalars['String']['output']>;
  registrationType: UserTeamRegistrationType;
  score: Scalars['Int']['output'];
};

export type UserTeamConnection = {
  __typename?: 'UserTeamConnection';
  edges: Array<UserTeamEdge>;
  pageInfo: PageInfo;
};

export type UserTeamEdge = {
  __typename?: 'UserTeamEdge';
  cursor: Scalars['Cursor']['output'];
  node: UserTeam;
};

export enum UserTeamRegistrationType {
  Free = 'FREE',
  Ticket = 'TICKET',
  Wallet = 'WALLET'
}

export type Viewer = {
  __typename?: 'Viewer';
  canDoWithdrawal: Scalars['Boolean']['output'];
  cards: CardConnection;
  features: Array<Scalars['ID']['output']>;
  gameStats: ViewerGameStats;
  gameTickets: Array<Scalars['ID']['output']>;
  gifts: GiftConnection;
  hasTonWallet: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inviterStats: InviterStats;
  name?: Maybe<Scalars['String']['output']>;
  nextRouletteSpinAt?: Maybe<Scalars['Time']['output']>;
  onboardingSteps: Array<Scalars['ID']['output']>;
  registeredAt: Scalars['Time']['output'];
  rouletteSpinsLeft: Scalars['Int']['output'];
  scores: ScoreConnection;
  startToken?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Subscription>;
  teams: UserTeamConnection;
  tonWallets: Array<Scalars['String']['output']>;
  wallet: Wallet;
  webappFirstStartedAt?: Maybe<Scalars['Time']['output']>;
};


export type ViewerCardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  citizenship?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedCards?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Array<PlayerPosition>>;
  rarities?: InputMaybe<Array<Rarity>>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
  tiers?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type ViewerGiftsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  games?: InputMaybe<Array<Scalars['ID']['input']>>;
  isClaimed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ViewerScoresArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  cards?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  games?: InputMaybe<Array<Scalars['ID']['input']>>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type ViewerTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ViewerGameStats = {
  __typename?: 'ViewerGameStats';
  hasPlayedNftGames: Scalars['Boolean']['output'];
  hasPlayedPaidGames: Scalars['Boolean']['output'];
  numberOfGamesPlayed: Scalars['Int']['output'];
};

export type Wallet = {
  __typename?: 'Wallet';
  availableCurrencies: Array<Currency>;
  balance: Money;
  defaultCurrency: Currency;
  seasonTicketSummary: SeasonTicketSummary;
  stakes: Array<StakeDetails>;
  tokens: Array<WalletToken>;
  transactions: WalletTransactionConnection;
};


export type WalletTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum WalletDepositType {
  Purchase = 'PURCHASE',
  Transfer = 'TRANSFER'
}

export enum WalletProvider {
  Neocrypto = 'NEOCRYPTO',
  Stars = 'STARS',
  Tonkeeper = 'TONKEEPER',
  Tonspace = 'TONSPACE',
  Trust = 'TRUST',
  Wallet = 'WALLET'
}

export type WalletToken = {
  __typename?: 'WalletToken';
  balance: Money;
  isConvertibleTo: Array<Currency>;
};

export type WalletTransaction = Node & {
  __typename?: 'WalletTransaction';
  actualSum: Money;
  address?: Maybe<Scalars['String']['output']>;
  bettingGame?: Maybe<BettingGame>;
  card?: Maybe<Card>;
  createdAt: Scalars['Time']['output'];
  game?: Maybe<Game>;
  id: Scalars['ID']['output'];
  lootBoxOffer?: Maybe<LootBoxOffer>;
  opType: WalletTransactionOpType;
  predictionAmountMinor?: Maybe<Scalars['String']['output']>;
  predictionDescription?: Maybe<PredictionBetDescription>;
  predictionTicketId?: Maybe<Scalars['String']['output']>;
  seasonTicket?: Maybe<SeasonTicket>;
  status: WalletTransactionStatus;
  taskCampaign?: Maybe<TaskCampaign>;
  type: WalletTransactionType;
  walletSum: Money;
};

export type WalletTransactionConnection = {
  __typename?: 'WalletTransactionConnection';
  edges: Array<WalletTransactionEdge>;
  pageInfo: PageInfo;
};

export type WalletTransactionEdge = {
  __typename?: 'WalletTransactionEdge';
  cursor: Scalars['Cursor']['output'];
  node: WalletTransaction;
};

export enum WalletTransactionOpType {
  Betting = 'BETTING',
  ClaimStake = 'CLAIM_STAKE',
  GameTicket = 'GAME_TICKET',
  InviterReward = 'INVITER_REWARD',
  JackpotReward = 'JACKPOT_REWARD',
  LootBox = 'LOOT_BOX',
  MoneyReward = 'MONEY_REWARD',
  PlayerCard = 'PLAYER_CARD',
  PredictionPayout = 'PREDICTION_PAYOUT',
  PredictionReserve = 'PREDICTION_RESERVE',
  PredictionReturn = 'PREDICTION_RETURN',
  Refund = 'REFUND',
  SeasonTicket = 'SEASON_TICKET',
  Staking = 'STAKING',
  Subscription = 'SUBSCRIPTION',
  TokenSwap = 'TOKEN_SWAP',
  Topup = 'TOPUP',
  Withdrawal = 'WITHDRAWAL'
}

export enum WalletTransactionStatus {
  Approved = 'APPROVED',
  ApproveRequired = 'APPROVE_REQUIRED',
  Captured = 'CAPTURED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Released = 'RELEASED',
  Reserved = 'RESERVED',
  Started = 'STARTED'
}

export enum WalletTransactionType {
  Deposit = 'DEPOSIT',
  Withdrawal = 'WITHDRAWAL'
}
